import { CREATE } from '@/constants/api'

export const INVENTORY = 'inventory'
export const STOCK = 'stock'
export const TRANSACTIONS = 'transactions'
export const CATEGORIES = 'categories'

export const ENDPOINTS = {
  // Stock (actual inventory quantities per church)
  LIST_STOCK: `/${INVENTORY}/${STOCK}`,
  GET_STOCK: `/${INVENTORY}/${STOCK}`,
  CREATE_STOCK: `/${INVENTORY}/${STOCK}/${CREATE}`,
  UPDATE_STOCK: `/${INVENTORY}/${STOCK}`,
  DELETE_STOCK: `/${INVENTORY}/${STOCK}`,

  // Transactions (IN/OUT)
  LIST_TRANSACTIONS: `/${INVENTORY}/${TRANSACTIONS}`,
  CREATE_TRANSACTION: `/${INVENTORY}/${TRANSACTIONS}/${CREATE}`,
  GET_TRANSACTION: `/${INVENTORY}/${TRANSACTIONS}`,
  DOWNLOAD_INVOICE: `/${INVENTORY}/${TRANSACTIONS}`,

  // Categories
  LIST_CATEGORIES: `/${INVENTORY}/${CATEGORIES}`,
  GET_CATEGORY: `/${INVENTORY}/${CATEGORIES}`,
  CREATE_CATEGORY: `/${INVENTORY}/${CATEGORIES}/${CREATE}`,
  UPDATE_CATEGORY: `/${INVENTORY}/${CATEGORIES}`,
  DELETE_CATEGORY: `/${INVENTORY}/${CATEGORIES}`,
}
